export default "__VITE_ASSET__CTM640ix__"